
const ReturnsThankYouComponent = {
	props: {
	},
	emits: [
	],
	setup( props, { emit } ) {
		return {
		};
	},
	template: `
		<div class="wizard-step-body justify-around py-8">
			<div>
				<div>La tua richiesta di reso è stata inviata ed è in fase di revisione.</div>
				<div>Ti invieremo un'email quando sarà completata.</div>
			</div>
		</div>
	`
}

export default ReturnsThankYouComponent;
